import React from 'react';
import { Col, Input, Row } from 'reactstrap';
import PropTypes from 'prop-types';

// import AppCheckboxList from 'components/App/AppCheckboxList';
// import AppFlatPickInput from 'components/App/FlatPickInput';
import AppInputNumberValidation from 'components/App/InputNumberValidation';
import AppInputValidation from 'components/App/InputValidation';
// import Button from 'components/App/Button';
import Card from 'components/App/Card';

import INITIAL_VALUE from 'constants/initialValue';
// import { ROOM_TYPE } from 'constants/index';
// import randomIDString from 'utils/randomId';
// import { convertIsoDateToString } from 'utils';

import styles from './FormCreateAccountPromotion.module.scss';

const PRICE_TYPE = {
  ALL_PRICE: 'ALL_PRICE',
  CHOOSE_PRICE: 'CHOOSE_PRICE',
};

const APPLY_FOR = {
  ALL_ROOM: 'ALL_ROOM',
  CHOOSE_ROOM: 'CHOOSE_ROOM',
};

function FormCreateAccountPromotion(props) {
  const {
    // isLongTerm,
    validation,
    // roomOfPlaceList,
    // placePriceTypes,
  } = props;

  const onChangeInputRadio = React.useCallback((e) => {
    validation.setFieldValue(e.target.name, !!+e.target.value);
  }, []);

  // const onToggleCheckedDateInWeek = React.useCallback((e) => {
  //   validation.setValues((values) => ({
  //     ...values,
  //     applyBookingDays: values.applyBookingDays.map((item) => {
  //       if (item.value === +e.target.value) {
  //         return {
  //           ...item,
  //           isChecked: e.target.checked,
  //         };
  //       }
  //       return item;
  //     }),
  //   }));
  // }, []);

  // const onToggleSelectAllDate = React.useCallback(
  //   (e) => {
  //     validation.setFieldValue(
  //       'applyBookingDays',
  //       validation.values.applyBookingDays.map((item) => ({
  //         ...item,
  //         isChecked: +e.target.value === 1,
  //       })),
  //     );
  //   },
  //   [validation.values],
  // );

  // const onChangeStartDate = React.useCallback((date) => {
  //   validation.setFieldValue('bookingStartAt', date[0]);
  // }, []);

  // const onChangeEndDate = React.useCallback((date) => {
  //   validation.setFieldValue('bookingEndAt', date[0]);
  // }, []);

  // const onAddstayAt = React.useCallback(() => {
  //   validation.setValues((values) => ({
  //     ...values,
  //     stayAt: [
  //       ...values.stayAt,
  //       {
  //         _id: randomIDString(),
  //         startAt: '',
  //         endAt: '',
  //       },
  //     ],
  //   }));
  // }, []);

  // const onDeletestayAt = React.useCallback(
  //   (id) => () => {
  //     validation.setValues((values) => ({
  //       ...values,
  //       stayAt: values.stayAt.filter((item) => item._id !== id),
  //     }));
  //   },
  //   [],
  // );

  // const onChangeStayAt = React.useCallback((date, name, id) => {
  //   validation.setValues((values) => ({
  //     ...values,
  //     stayAt: values.stayAt.map((item) => {
  //       if (item._id === id) {
  //         return {
  //           ...item,
  //           [name]: date[0],
  //         };
  //       }
  //       return item;
  //     }),
  //   }));
  // }, []);

  // const onChangeCheckbox = React.useCallback((e) => {
  //   validation.setValues((values) => ({
  //     ...values,
  //     [e.target.name]: e.target.checked ? [
  //       ...values[e.target.name],
  //       e.target.value,
  //     ] : values.rooms.filter((item) => item !== e.target.value),
  //   }));
  // }, []);

  return (
    <>
      <Card className={styles.Section}>
        <h3 className={styles.Title}>Thông tin chi tiết về khuyến mãi</h3>

        {/* {isLongTerm && (
          <div className={styles.FormField}>
            <p className={styles.FormFieldTitle}>
              Khách cần lưu trú bao lâu để được sử dụng khuyến mãi này?
            </p>

            <div className={styles.SelectWrapper}>
              <p>
                Chọn số đêm tối thiểu
              </p>

              <Row>
                <Col md="5">
                  <AppInputNumberValidation
                    name="minStayNights"
                    keyName="minStayNights"
                    placeholder="Nhập số đêm"
                    validation={validation}
                    thousandSeparator=""
                    onBlur={validation.handleBlur}
                    value={validation.values.minStayNights}
                  />
                </Col>
              </Row>
            </div>
          </div>
        )} */}

        <div className={styles.FormField}>
          <p className={styles.FormFieldTitle}>
            Loại giá nào sẽ được áp dụng khuyến mãi này?
          </p>

          <label htmlFor={PRICE_TYPE.ALL_PRICE}>
            <Input
              id={PRICE_TYPE.ALL_PRICE}
              name="isAllPriceTypes"
              value={1}
              type="radio"
              validation={validation}
              onChange={onChangeInputRadio}
              checked={validation.values.isAllPriceTypes}
            />

            <span>Tất cả loại giá</span>
          </label>

          {/* <div>
            <label htmlFor={PRICE_TYPE.CHOOSE_PRICE}>
              <Input
                id={PRICE_TYPE.CHOOSE_PRICE}
                name="isAllPriceTypes"
                value={0}
                type="radio"
                validation={validation}
                onChange={onChangeInputRadio}
                checked={!validation.values.isAllPriceTypes}
              />

              <span>Chọn loại giá</span>
            </label>

            {!validation.values.isAllPriceTypes && (
            <div className={styles.SelectOption}>
              {placePriceTypes.map((item) => (
                <label htmlFor={item._id} key={item._id}>
                  <Input
                    id={item._id}
                    name="priceTypes"
                    type="checkbox"
                    value={item._id}
                    validation={validation}
                    onChange={onChangeCheckbox}
                    checked={validation.values.priceTypes.includes(item._id)}
                  />

                  <span>{item.name}</span>
                </label>
              ))}
              {validation.errors?.priceTypes && validation.touched?.priceTypes && (
              <FormFeedback type="invalid" className="d-block font-size-12">
                {validation.errors.priceTypes}
              </FormFeedback>
              )}
            </div>
            )}
          </div> */}
        </div>

        <div className={styles.FormField}>
          <p className={styles.FormFieldTitle}>Phòng nào sẽ được áp dụng?</p>

          <label htmlFor={APPLY_FOR.ALL_ROOM}>
            <Input
              id={APPLY_FOR.ALL_ROOM}
              name="isAllRooms"
              value={1}
              type="radio"
              validation={validation}
              onChange={onChangeInputRadio}
              checked={validation.values.isAllRooms}
            />

            <span>Tất cả phòng được cài đặt tất cả loại giá đã chọn</span>
          </label>

          {/* <div>
            <label htmlFor={APPLY_FOR.CHOOSE_ROOM}>
              <Input
                id={APPLY_FOR.CHOOSE_ROOM}
                name="isAllRooms"
                value={0}
                type="radio"
                validation={validation}
                onChange={onChangeInputRadio}
                checked={!validation.values.isAllRooms}
              />

              <span>Chọn phòng</span>
            </label>

            {!validation.values.isAllRooms && (
            <div className={styles.SelectOption}>
              {roomOfPlaceList.map((item) => (
                <label htmlFor={item._id} key={item._id}>
                  <Input
                    id={item._id}
                    name="rooms"
                    value={item._id}
                    type="checkbox"
                    validation={validation}
                    onChange={onChangeCheckbox}
                    checked={validation.values.rooms.find((room) => room === item._id)}
                  />

                  <span>{item.name || ROOM_TYPE[item.roomName]?.label}</span>
                </label>
              ))}
              {validation.errors?.rooms && validation.touched?.rooms && (
              <FormFeedback type="invalid" className="d-block font-size-12">
                {validation.errors.rooms}
              </FormFeedback>
              )}
            </div>
            )}
          </div> */}
        </div>

        <div className={styles.FormField} style={{ gap: '12px' }}>
          <p className={styles.FormFieldTitle}>Giảm giá</p>

          <Row>
            <Col md={5}>
              <AppInputNumberValidation
                name="discountRate"
                keyName="discountRate"
                placeholder="Nhập mức giảm giá"
                thousandSeparator=""
                validation={validation}
                onBlur={validation.handleBlur}
                showCurrency="%"
                formatOptions={{ decimalScale: 0 }}
              />
            </Col>
          </Row>
          <p className={styles.DiscountDescription}>
            Kết hợp được với:
            {' '}
            <span>Kết hợp với nhóm khuyến mãi Phổ biến và Giới hạn</span>
          </p>
        </div>
      </Card>

      {/* <Card className={styles.Section}>
        <h3 className={styles.Title}>Ngày lưu trú</h3>

        <div className={styles.FormField}>
          <p className={styles.FormFieldTitle}>Thời gian đặt</p>

          <Row className={styles.Flex}>
            <Col md={5}>
              <AppFlatPickInput
                name="bookingStartAt"
                keyName="bookingStartAt"
                placeholder="Chọn ngày bắt đầu"
                validation={validation}
                onChange={onChangeStartDate}
                isShowError
                value={validation.values.bookingStartAt}
                options={{
                  minDate: 'today',
                }}
              />
            </Col>
            <span className={styles.Dash}>-</span>
            <Col md={5}>
              <AppFlatPickInput
                placeholder="Chọn ngày kết thúc"
                validation={validation}
                onChange={onChangeEndDate}
                name="bookingEndAt"
                keyName="bookingEndAt"
                isShowError
                value={validation.values.bookingEndAt}
                options={{
                  minDate: 'today',
                }}
              />
            </Col>
          </Row>
        </div>
        <div className={styles.FormField}>
          <p className={styles.FormFieldTitle}>Thời gian lưu trú</p>

          {validation.values.stayAt?.map((item, index) => (
            <Row className={styles.ItemCenter} key={item._id}>
              <Col md={5}>
                <AppFlatPickInput
                  id={item._id}
                  name="startAt"
                  placeholder="Chọn ngày bắt đầu"
                  validation={validation}
                  onChange={onChangeStayAt}
                  value={item.startAt}
                  options={{
                    minDate: 'today',
                  }}
                />
              </Col>
              -
              <Col md={5}>
                <AppFlatPickInput
                  id={item._id}
                  name="endAt"
                  placeholder="Chọn ngày kết thúc"
                  validation={validation}
                  onChange={onChangeStayAt}
                  value={item.endAt}
                  options={{
                    minDate: 'today',
                  }}
                />
              </Col>
              {index > 0 && (
                <Button
                  isDefault
                  classes={styles.ButtonDelete}
                  type="button"
                  onClick={onDeletestayAt(item._id)}
                >
                  Xoá
                </Button>
              )}
            </Row>
          ))}
          {validation.errors?.stayAt && validation.touched?.stayAt && (
            <FormFeedback type="invalid" className="d-block font-size-12">
              {validation.errors.stayAt}
            </FormFeedback>
          )}

          <Button
            outline
            color="light"
            classes={styles.Button}
            onClick={onAddstayAt}
          >
            <i className="fas fa-plus" />
            Thêm
          </Button>
        </div>

        <div>
          <p className={`${styles.FormFieldTitle} mb-1`}>
            Bạn muốn áp dụng khuyến mãi này vào ngày nào trong tuần?
          </p>
          <span className={styles.FormFieldSubTitle}>
            Bỏ chọn ngày trong tuần để ngày đó không xuất hiện trong lịch áp
            dụng khuyến mãi
          </span>
        </div>

        <AppCheckboxList
          name="applyBookingDays"
          list={validation.values.applyBookingDays}
          validation={validation}
          onChecked={onToggleCheckedDateInWeek}
          onToggleCheckedAll={onToggleSelectAllDate}
        />

        <div className={styles.SummaryPromotion}>
          <p className={styles.FormFieldTitle}>
            Giảm giá sẽ được áp dụng cho các lưu trú trong khoảng thời gian sau:
          </p>

          {validation.values.stayAt.map(
            (item) =>
              item.startAt &&
              item.endAt && (
                <span className={styles.FormFieldSubTitle} key={item.id}>
                  {`${convertIsoDateToString(item.startAt, 'D [tháng] M yyyy')}
                  – ${convertIsoDateToString(item.endAt, 'D [tháng] M yyyy')}`}
                </span>
              ),
          )}
        </div>
      </Card> */}

      <Card className={styles.Section}>
        <h3 className={styles.Title}>Tên khuyến mãi</h3>

        <div className={styles.FormField}>
          <div className={styles.FormFieldTitleWrapper}>
            <p className={styles.FormFieldTitle}>
              Quý vị muốn đặt tên khuyến mãi này là gì?
            </p>

            <span className={styles.FormFieldSubTitle}>
              Tên này chỉ dành cho Quý vị. Chúng tôi sẽ không hiển thị tên cho
              khách trên Bookese.com.
            </span>
          </div>
          <AppInputValidation
            type="text"
            id="name"
            name="name"
            validation={validation}
            placeholder="Nhập tên khuyến mãi"
          />
        </div>
      </Card>
    </>
  );
}

FormCreateAccountPromotion.propTypes = {
  // isLongTerm: PropTypes.bool,
  validation: PropTypes.instanceOf(Object),
  // roomOfPlaceList: PropTypes.instanceOf(Array),
  // placePriceTypes: PropTypes.instanceOf(Array),
};

FormCreateAccountPromotion.defaultProps = {
  // isLongTerm: false,
  validation: INITIAL_VALUE.OBJECT,
  // roomOfPlaceList: INITIAL_VALUE.ARRAY,
  // placePriceTypes: INITIAL_VALUE.ARRAY,
};

export default FormCreateAccountPromotion;
